export function FloatToPercBasisPointParser(value: number) {
    const result = value*100;
    return new Intl.NumberFormat('en-GB', {maximumFractionDigits: 4}).format(value*100) + "%";
}

export function PercBasisToFloatParser(value: string) {
    const result = parseFloat(value)/100;
    return  new Intl.NumberFormat('en-GB', {maximumFractionDigits: 4}).format(result)
}
